import { useTranslation } from "react-i18next";
import { Box, Grid } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useAuth } from "@emberly/zenith-client";
import axios from "axios";
import NetworkStationSearch from "./NetworkStationSearch";
import NetworkStationMap from "./NetworkStationMap";
import { useStation } from "../../../../providers/StationProvider";
import { HaversineDistance } from "../../../../common/maphelpers";
import { formatText } from "../../../../common/helpers";
import fuzzysort from "fuzzysort";
import { useDevice } from "../../../../providers/DeviceProvider";


export default function NetworkStationPickerSection(props) {
  const { onSelected } = props;
  const { t } = useTranslation();
  const { getAccessTokenSilently } = useAuth();
  const { station } = useStation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [stations, setStations] = useState([]);
  const [query, setQuery] = useState("");
  const [expanded, setExpanded] = useState("");
  const { slim } = useDevice();

  useEffect(() => {

    const fn = async () => {
      try {

        const res = await axios("/api/station/network/list", {
          headers: { Authorization: `Bearer ${await getAccessTokenSilently()}` },
        });

        // TODO filter out own station.

        if (station?.location?.coordinates?.length === 2) {

          let coords = station.location.coordinates;

          let list = res.data
            .filter(s => s.id !== station.id)
            .map((s) => ({
              ...s,
              query: formatText(" ", s.displayName, s.services.map(t => t.name).join(" ")),
              distance: s.location?.coordinates?.length === 2 ? Math.max(0, HaversineDistance(coords[0], coords[1], s.location.coordinates[0], s.location.coordinates[1])) : undefined
            }))
            .sort((a, b) => typeof a.distance === "number" && b.distance === "number" ? b.distance - a.distance : 999999)

          setStations(list);
        } else {
          setStations(res.data);
        }

      } catch (err) {
        console.log(err)
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    if (!!station) {
      fn();
    }

  }, [getAccessTokenSilently, station]);

  let filteredStations = useMemo(() => {
    if (!query) return stations;
    return fuzzysort.go(query, stations, { key: "query" }).filter(t => t.score > 0.3).map(t => t.obj);
  }, [query, stations]);


  return (
    <Box sx={{ height: "100%" }}>
      <Grid container spacing={2} sx={{ height: "100%" }}>

        <Grid item xs={12} lg={5} sx={{ height: "100%" }}>
          <NetworkStationSearch
            stations={stations}
            loading={loading}
            onSelected={onSelected}
            filteredStations={filteredStations}
            query={query}
            setQuery={setQuery}
            expanded={expanded}
            setExpanded={setExpanded}
          />
        </Grid>

        {!slim ? (
          <Grid item xs={12} lg={7} sx={{ minHeight: "100%" }}>
            <NetworkStationMap
              stations={stations}
              loading={loading}
              onSelected={onSelected}
              filteredStations={filteredStations}
              query={query}
              setQuery={setQuery}
              expanded={expanded}
              setExpanded={setExpanded}
            />
          </Grid>
        ) : null}

      </Grid>
    </Box>
  );
}

